<template>
    <b-modal
        id="exportStudentModal"
        title="Exportar Alunos em Planilha"
        hide-footer
    >
        <!-- Field -->
        <b-form-group
            label="Data Inicial">
            <!-- Input -->
            <b-input-group>
                <b-form-datepicker
                    v-model="form.from"
                    locale="pt"
                ></b-form-datepicker>
                <template v-slot:append>
                    <b-button variant="outline-danger" aria-label="Limpar" @click="form.from = null">
                        <i class="fas fa-times"></i>
                    </b-button>
                </template>
            </b-input-group>
        </b-form-group>

        <!-- Field -->
        <b-form-group
            label="Data Final">
            <!-- Input -->
            <b-input-group>
                <b-form-datepicker
                    v-model="form.to"
                    locale="pt"
                ></b-form-datepicker>
                <template v-slot:append>
                    <b-button variant="outline-danger" aria-label="Limpar" @click="form.to = null">
                        <i class="fas fa-times"></i>
                    </b-button>
                </template>
            </b-input-group>
        </b-form-group>

        <!-- Field -->
        <b-form-group
            label="Turma"
            description="Deseja filtrar os alunos por turma ?">

            <multiselect
                v-model="group"
                :options="groups"
                :loading="loadingGroup"
                track-by="id"
                label="name"
                placeholder=""
                @select="selectGroup"
                @remove="removeGroup"
                @search-change="searchGroup"
                tag-placeholder="Filtrar Turma"
                selectLabel="Selecionar"
                deselectLabel="Desmarcar"
                selectedLabel="Selecionado">

                    <span slot="noResult">
                        Ops! Nenhum resultado encontrado na pesquisa :(
                    </span>

                    <span slot="noOptions">
                        Não há turmas disponíveis para exibir :(
                    </span>

            </multiselect>
        </b-form-group>

        <!-- Field -->
        <b-form-group
            label="Aluno"
            description="Deseja selecionar um aluno específico ?">

            <multiselect
                v-model="student"
                :options="students"
                :loading="loadingStudent"
                track-by="id"
                label="name"
                placeholder=""
                @select="selectStudent"
                @remove="removeStudent"
                @search-change="searchStudent"
                tag-placeholder="Filtrar Aluno"
                selectLabel="Selecionar"
                deselectLabel="Desmarcar"
                selectedLabel="Selecionado">

                    <span slot="noResult">
                        Ops! Nenhum resultado encontrado na pesquisa :(
                    </span>

                    <span slot="noOptions">
                        Não há alunos disponíveis para exibir :(
                    </span>

            </multiselect>
        </b-form-group>

        <b-form-group>
            <a :href="urlFinal" target="_blank" class="btn btn-outline-primary">
                <i class="fas fa-file-export mr-1"></i>
                Exportar em Planilha
            </a>
        </b-form-group>
    </b-modal>
</template>

<script>
export default {
    props: [],
    data() {
        return {
            loadingGroup: false,
            loadingStudent: false,
            id: null,
            form: {
                from: null,
                to: null,
                group_id: null,
                student_id: null
            },
            groups: [],
            students: [],
            group: null,
            student: null
        }
    },
    computed: {
        urlFinal() {
            let url = '/teacher/students/export?';

            if (this.form.from)
                url += '&from=' + this.form.from

            if (this.form.to)
                url += '&to=' + this.form.to

            if (this.form.group_id)
                url += '&group_id=' + this.form.group_id

            if (this.form.student_id)
                url += '&student_id=' + this.form.student_id

            return url;
        }
    },
    created() {
        this.$root.$on('openExportStudentModal', async () => {
            this.form = {
                from: null,
                to: null,
                group_id: null,
                student_id: null
            }

            this.$bvModal.show('exportStudentModal')

            // Load Groups
            await this.searchGroup(null)

            // Load Students
            await this.searchStudent(null, true)
        })
    },
    methods: {

        searchGroup(text) {
            this.loadingGroup = true;
            axios.get('/teacher/groups/search', {
                params: {
                    name: text
                }
            })
                .then((result) => {
                    this.groups = result.data.data.groups;
                })
                .finally(() => this.loadingGroup = false)
        },

        searchStudent(text, searchViaQuery = false) {
            this.loadingStudent = true;
            axios.get('/teacher/students/search', {
                params: {
                    group_id: this.form.group_id,
                    name: text
                }
            })
                .then(async (result) => {
                    this.students = await result.data.data.students;
                })
                .finally(() => this.loadingStudent = false)
        },

        async selectGroup(value) {
            this.form.group_id = await value.id;
            this.form.student_id = await null
            this.student = await null

            // Load Students
            await this.searchStudent(null)
        },

        async removeGroup() {
            this.form.group_id = await null
            this.form.student_id = await null
            this.student = await null

            // Load Students
            await this.searchStudent(null)
        },

        async selectStudent(value) {
            this.form.student_id = await value.id;
        },

        async removeStudent() {
            this.form.student_id = await null
        },
    }
}
</script>

<style scoped>

</style>
